import * as React from 'react';
import { PdsIconRefreshCw as PdsIconRefreshCwElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconRefreshCw = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-refresh-cw',
  elementClass: PdsIconRefreshCwElement,
  react: React,
});
